import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
// import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import { useFormik, Formik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import TextField from '@material-ui/core/TextField';
// import { withStyles } from '@material-ui/core/styles';
import { purple } from '@material-ui/core/colors';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Card, CardContent } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Multiselect } from 'multiselect-react-dropdown';
// import ButtonComp from '../../components/button';
// import './servicestyles.css';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    bottomLine: {
        borderBottom: '1px solid #ccc !important',
    },
    margn: {
        marginTop: '6px !important',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
});

const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4e4cac',
            '& + $track': {
                backgroundColor: '#a6a4d6',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: '#cac8ec',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});

function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function SuperAdminMatrix(props) {
    // const tokens = token();
    const classes = useStyles();

    const vertical = 'top';
    const horizontal = 'center';
    const [state, setState] = React.useState({
        checkedNewClient: true,
        checkedLoginFomalitiesClient: true,
        checkedCredentialsClient: true,
        checkedLoginCredentials: true,
        checkedResetPass: true,
        checkedForgotPass: true,
        checkedEmpOnboarding: true,
        checkedAssignRole: true,
        checkedUserRole: true,
        checkedCreateServiceRequest: true,
        checkedListAudits: true,
        checkedStarItr: true,
        checkedApcServices: true,
        checkedViewInvoices: true,
        checkedOptionPayments: true,
        checkedOptionPaymentsHistory: true,
        checkedOptionProfile: true,
        checkedNotification: true,
        checkedClientOnboarding: true,
        checkedAuditRequest: true,
        checkedItrRequest: true,
        checkedInvoice: true,
        checkedApcRequest: true,
        checkedClientListRequest: true,
        checkedAuditFlow: false,
        checkedItrFlow: true,
        checkedInvoiceApc: true,
        checkedInvoiceAudit: false,
        checkedInvoiceItr: true,
        checkedInvoicePagination: false,
        checkedParticularInvoice: true,
        checkedInvoiceDetail: false,
        checkedPaymentGateway: true,
        checkedTransactionDetail: true,
        checkedListPaymentTransaction: true,
        checkedRoleBasedRemainders: false,
        checkedFlowWiseRemainders: true,
        checkedUploadingTheDocumentsInVariousStages: false,
        checkedReviewingAndAddingRemarks: true,
        checkedAssigningAndSharingToNextRole: false,
        checkedAccountingProcessFlow: true,
        checkedPayrollProcessFlow: false,
        checkedGSTMonthly: false,
        checkedTDSPFPTComplianceProcessFlow: true,
        checkedGenericFlow: true,
    });
    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    //console.log(formik.values,"Values");
    //console.log(selectedDate,"Values");

    return (
        <>
            <Snackbar
                className="deleteError"
                // open={updateStat}
                anchorOrigin={{ vertical, horizontal }}
                autoHideDuration={3000}
                onClose={() => {
                    // setUpdateStat(false);
                }}
            >
                <Alert
                    onClose={() => {
                        // setUpdateStat(false);
                    }}
                >
                    updated successfully
                </Alert>
            </Snackbar>
            <form className="itecform">
                <Card className="clientcard">
                    <CardContent className="client-heading">Manage Team and Permission</CardContent>

                    <CardContent>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth className={classes.margin}>
                                <div>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            defaultValue="letout"
                                            aria-label="aadhar"
                                            name="customized-radios"
                                            className="radio-option"
                                        >
                                            <ul className={classes.inlineDisplay}>
                                                <li>
                                                    <FormControlLabel value="letout" control={<StyledRadio />} label="Team" />
                                                </li>
                                                <li>
                                                    <FormControlLabel value="selfOccupied" control={<StyledRadio />} label="ITeC Team" />
                                                </li>
                                                <li>
                                                    <FormControlLabel value="vacant" control={<StyledRadio />} label="Ultimate Client" />
                                                </li>
                                            </ul>
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Typography variant="subtitle1" gutterBottom>
                                Select Designation
                            </Typography>
                            <FormControl fullWidth>
                                {/* <InputLabel className="lbl" htmlFor="selectimc" shrink>
                                    Select IMC
                                </InputLabel> */}
                                <Select native className="bottom" name="intclientName">
                                    <option value="" selected>
                                        Admin
                                    </option>
                                    <option value="" selected>
                                        Select IMC
                                    </option>
                                    <option value="" selected>
                                        Select IMC
                                    </option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TableContainer>
                                <Table className={classes.table} aria-label="spanning table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left" colSpan={3}>
                                                Feature
                                            </TableCell>
                                            <TableCell align="left">Sub Feature</TableCell>
                                            <TableCell align="right">Toggle On/Off</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {/* On Boarding Client */}
                                        <TableRow>
                                            <TableCell rowSpan={3}>On Boarding-Client </TableCell>
                                            <TableCell colSpan={3}>Onboarding new client</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedNewClient}
                                                            onChange={handleChange}
                                                            name="checkedNewClient"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Creating login formalities for client</TableCell>
                                            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedLoginFomalitiesClient}
                                                            onChange={handleChange}
                                                            name="checkedLoginFomalitiesClient"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Sharing the cerdentials to client</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedCredentialsClient}
                                                            onChange={handleChange}
                                                            name="checkedCredentialsClient"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Login */}
                                        <TableRow>
                                            <TableCell rowSpan={3}>Login </TableCell>
                                            <TableCell colSpan={3}>Login through credentials/OTP</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedLoginCredentials}
                                                            onChange={handleChange}
                                                            name="checkedLoginCredentials"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Reset Password</TableCell>
                                            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedResetPass}
                                                            onChange={handleChange}
                                                            name="checkedResetPass"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Forgot Password</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedForgotPass}
                                                            onChange={handleChange}
                                                            name="checkedForgotPass"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* User Role Management */}
                                        <TableRow>
                                            <TableCell rowSpan={3}>User / Role Management </TableCell>
                                            <TableCell colSpan={3}>User / Employee Onboarding and off boarding</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedEmpOnboarding}
                                                            onChange={handleChange}
                                                            name="checkedEmpOnboarding"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Team / Group Creation and modification</TableCell>
                                            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedTeamCreation}
                                                            onChange={handleChange}
                                                            name="checkedTeamCreation"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Assigning role based features</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedAssignRole}
                                                            onChange={handleChange}
                                                            name="checkedAssignRole"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Dashboard */}
                                        <TableRow>
                                            <TableCell rowSpan={10}>Dashboard </TableCell>
                                            <TableCell colSpan={3}>User role based dashboard</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedUserRole}
                                                            onChange={handleChange}
                                                            name="checkedUserRole"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to create a service request</TableCell>
                                            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedCreateServiceRequest}
                                                            onChange={handleChange}
                                                            name="checkedCreateServiceRequest"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to view and start list of audits</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedListAudits}
                                                            onChange={handleChange}
                                                            name="checkedListAudits"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to view and start ITR</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedStarItr}
                                                            onChange={handleChange}
                                                            name="checkedStarItr"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to view and start list of APC services</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedApcServices}
                                                            onChange={handleChange}
                                                            name="checkedApcServices"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to view invoices</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedViewInvoices}
                                                            onChange={handleChange}
                                                            name="checkedViewInvoices"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to do payments</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedOptionPayments}
                                                            onChange={handleChange}
                                                            name="checkedOptionPayments"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to do payments history</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedOptionPaymentsHistory}
                                                            onChange={handleChange}
                                                            name="checkedOptionPaymentsHistory"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to go profile</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedOptionProfile}
                                                            onChange={handleChange}
                                                            name="checkedOptionProfile"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Option to see notification or reminders</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedNotification}
                                                            onChange={handleChange}
                                                            name="checkedNotification"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Create Service Request */}
                                        <TableRow>
                                            <TableCell rowSpan={5}>Create Service Requests </TableCell>
                                            <TableCell colSpan={3}>Create a client onboarding request</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedClientOnboarding}
                                                            onChange={handleChange}
                                                            name="checkedClientOnboarding"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Create on Audit request</TableCell>
                                            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedAuditRequest}
                                                            onChange={handleChange}
                                                            name="checkedAuditRequest"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Create on ITR request</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedItrRequest}
                                                            onChange={handleChange}
                                                            name="checkedItrRequest"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Create an Invoice</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedInvoice}
                                                            onChange={handleChange}
                                                            name="checkedInvoice"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Create an APC request</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedApcRequest}
                                                            onChange={handleChange}
                                                            name="checkedApcRequest"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* List of Request */}
                                        <TableRow>
                                            <TableCell rowSpan={1}>List of Requests </TableCell>
                                            <TableCell colSpan={3}>All the request created ( Based on user/Roles ) </TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedClientListRequest}
                                                            onChange={handleChange}
                                                            name="checkedClientListRequest"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Audit Flow */}
                                        <TableRow>
                                            <TableCell rowSpan={1}>Audit Flow </TableCell>
                                            <TableCell colSpan={3}>The sub features are explained in next excel tab </TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedAuditFlow}
                                                            onChange={handleChange}
                                                            name="checkedAuditFlow"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* ITR Flow */}
                                        <TableRow>
                                            <TableCell rowSpan={1}>ITR Flow </TableCell>
                                            <TableCell colSpan={3}>The sub features are explained in next excel tab </TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedItrFlow}
                                                            onChange={handleChange}
                                                            name="checkedItrFlow"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Invoice Generation */}
                                        <TableRow>
                                            <TableCell rowSpan={3}>Invoice Generation </TableCell>
                                            <TableCell colSpan={3}>Invoice for audit</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedInvoiceAudit}
                                                            onChange={handleChange}
                                                            name="checkedInvoiceAudit"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Invoice for ITR</TableCell>
                                            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedInvoiceItr}
                                                            onChange={handleChange}
                                                            name="checkedInvoiceItr"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Invoice for APC</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedInvoiceApc}
                                                            onChange={handleChange}
                                                            name="checkedInvoiceApc"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* List of Invoice */}
                                        <TableRow>
                                            <TableCell rowSpan={3}>List of Invoice </TableCell>
                                            <TableCell colSpan={3}>View all invoices with pagination support </TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedInvoicePagination}
                                                            onChange={handleChange}
                                                            name="checkedInvoicePagination"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Search particular Invoice</TableCell>
                                            {/* <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell> */}
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedParticularInvoice}
                                                            onChange={handleChange}
                                                            name="checkedParticularInvoice"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Invoice detail</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedInvoiceDetail}
                                                            onChange={handleChange}
                                                            name="checkedInvoiceDetail"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Invoice payments Payment gateway Integration */}
                                        <TableRow>
                                            <TableCell rowSpan={1}>Invoice payments Payment gateway Integration </TableCell>
                                            <TableCell colSpan={3}>Payment through Payment gateway</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedPaymentGateway}
                                                            onChange={handleChange}
                                                            name="checkedPaymentGateway"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Payment History */}
                                        <TableRow>
                                            <TableCell rowSpan={2}>Payment History </TableCell>
                                            <TableCell colSpan={3}>List of Payment / transactions </TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedListPaymentTransaction}
                                                            onChange={handleChange}
                                                            name="checkedListPaymentTransaction"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Transaction detail</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedTransactionDetail}
                                                            onChange={handleChange}
                                                            name="checkedTransactionDetail"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* Followups and notifications */}
                                        <TableRow>
                                            <TableCell rowSpan={2}>
                                                Followups and notifications
                                                <br />
                                                SMS, Calls, Whatsapp and Emails{' '}
                                            </TableCell>
                                            <TableCell colSpan={3}>Role based remainders / notifications and Followups calls </TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedRoleBasedRemainders}
                                                            onChange={handleChange}
                                                            name="checkedRoleBasedRemainders"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Flow wise remainders / notifications and Followups calls</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedFlowWiseRemainders}
                                                            onChange={handleChange}
                                                            name="checkedFlowWiseRemainders"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* documents upload, Review remarks and share */}
                                        <TableRow>
                                            <TableCell rowSpan={3}>Documents upload, Review remarks and share </TableCell>
                                            <TableCell colSpan={3}>Uploading the documents in various stages / flows</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedUploadingTheDocumentsInVariousStages}
                                                            onChange={handleChange}
                                                            name="checkedUploadingTheDocumentsInVariousStages"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Reviewing and adding remarks</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedReviewingAndAddingRemarks}
                                                            onChange={handleChange}
                                                            name="checkedReviewingAndAddingRemarks"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>
                                                Assigning and sharing it to next role(client, CT or ITeC) via email or notifying
                                            </TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedAssigningAndSharingToNextRole}
                                                            onChange={handleChange}
                                                            name="checkedAssigningAndSharingToNextRole"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        {/* APC Flow */}
                                        <TableRow>
                                            <TableCell rowSpan={5}>APC Flow</TableCell>
                                            <TableCell colSpan={3}>Accounting process flow</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedAccountingProcessFlow}
                                                            onChange={handleChange}
                                                            name="checkedAccountingProcessFlow"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Payroll process flow</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedPayrollProcessFlow}
                                                            onChange={handleChange}
                                                            name="checkedPayrollProcessFlow"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>GST monthly / Quaterly return process flow</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedGSTMonthly}
                                                            onChange={handleChange}
                                                            name="checkedGSTMonthly"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>TDS, PF, ESI&PT Compliance process flow</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedTDSPFPTComplianceProcessFlow}
                                                            onChange={handleChange}
                                                            name="checkedTDSPFPTComplianceProcessFlow"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3}>Generic Flow</TableCell>
                                            <TableCell align="right">
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch
                                                            checked={state.checkedGenericFlow}
                                                            onChange={handleChange}
                                                            name="checkedGenericFlow"
                                                        />
                                                    }
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </CardContent>
                </Card>
                {/* <div style={{ display: catchErrorDiv }}>
                    <div className="errorMsgRed">{errormsg}</div>
                </div> */}
                {/* <div className="createintermediary-btndiv">
                    
                    <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
                        <li style={{ display: 'inline-block' }}>
                            {(showLoader ? (
                                <LoaderPopUp showLoader={showLoader} handleClose={handleClose} title="Please wait while we save data" />
                            ) : null) || <ButtonComp type="submit" className="intermediarybutn" title="Save" />}
                        </li>
                        <li style={{ display: 'inline-block', paddingLeft: '10px' }}>
                            <ButtonComp onClick={cancelFunc} className="intermediarybutn" title="Cancel" type="button" />
                        </li>
                    </ul>
                </div> */}
            </form>
        </>
    );
}
